<template>
  <div>
    <v-card class="elevation-0">
      <v-container container--fluid grid-list-md>
        <v-card-title>
          <v-row no-gutters>
            <v-col md="2" class="offset-md-5">
              <h2>Credit Notes</h2>
            </v-col>

            <v-col md="3" class="offset-md-2 d-flex justify-end align-center">

              <v-btn   @click="exportCreditNote(creditNoteInformation[0])" dark color="blue darken-1" small fab class="mr-2">
                <v-icon>download</v-icon>
              </v-btn>

              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn v-if="createButton" dark color="blue darken-1" small fab v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="$emit('add')">
                    <v-list-item-title>Raise a credit card</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>

        </v-card-title>
        <v-row justify="center">
          <v-col cols="12">
            <v-data-table
              :items="creditNoteInformation"
              :headers="headers"
            >
              <template v-slot:item="props">
                <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                  <td style="text-align: center">
                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on }">
                        <v-icon :color="props.item.closed ? '#BDBDBD' : 'orange'" v-on="on">fiber_manual_record</v-icon>
                      </template>
                      <span>Credit note {{props.item.closed ? 'closed' : 'opened'}}</span>
                    </v-tooltip>
                  </td>
                  <td style="text-align: center">{{props.item.id}}</td>
                  <td style="text-align: center">{{props.item.date }}</td>
                  <td style="text-align: center">${{(props.item.line_total)}}</td>
                  <td style="text-align: center">${{(props.item.total)}}</td>
                  <td style="text-align: center" v-if="editPermission" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                    <v-icon
                      color="warning"
                      class="pl-2"
                      @click="clickEdit(props.item)"
                    >fas fa-list-ul
                    </v-icon>
                    <v-icon
                      color="indigo"
                      @click="displayPdfInvoice(props.item)"
                      class="pl-2"
                      v-if="closedInvoice"
                    >fas fa-eye
                    </v-icon>
                    <v-icon
                      color="blue darken-1"
                      @click="csvExport(props.item)"
                      class="pl-2"
                    >fas fa-file-export
                    </v-icon>

                    <v-icon
                      color="green"
                      @click="displayCloseMessage(props.item)"
                      class="pl-2"
                      v-if="closedInvoice"
                      :disabled="props.item.closed"
                    >fas fa-paper-plane
                    </v-icon>

                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on }">
                        <v-icon @click="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                          delete
                        </v-icon>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog width="350px" v-model="editDialog">
      <v-card>
        <v-card-title class="headline justify-center">Edit Credit Note Nº {{}}</v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog v-model="creditNoteDisplayerDialog" fullscreen hide-overlay
              transition="dialog-bottom-transition" v-if="creditNoteInformation">
      <CreditNoteDisplayer
        v-if="creditNoteDisplayerDialog"
        v-on:update-credit-note-table="$emit('update-credit-note-table')"
        :toggle-dialog="toggleCreditNoteDialog"
        :credit-note-info="editedNote"
        :edit="editPermission"
        :regions="regions"
      ></CreditNoteDisplayer>
    </v-dialog>

    <v-dialog
      v-model="confirmCloseDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Do you want to send this credit note after you closed it ?
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              If so, to what email ? (If different from your default one)
              <v-text-field
                :rules="emailRules"
                prepend-icon="mail"
                v-model="emailTo"
                label="Email Address..."
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="red" text @click="confirmCloseDialog=false; emailTo=''">Cancel</v-btn>
          <v-btn text @click="closeCreditNote('no')"  :disabled="!editPermission">No</v-btn>
          <v-btn color="blue darken-1" text @click="closeCreditNote('yes')">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this Credit Note. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="DeleteCreditNote" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InvoiceDisplayer from "./InvoiceDisplayer";
import CreditNoteDisplayer from "./CreditNoteDisplayer";
import axios from 'axios'

// @vuese
// Table of all the credit notes (displayed in expandable invoice table)
// @group Invoices
export default {
  name: "CreditNoteTable",
  components: {CreditNoteDisplayer, InvoiceDisplayer},
  props: {
    creditNoteInformation: Array,
    editPermission: Boolean,
    actionDisable: Boolean,
    regions: Array,
    closedInvoice: Boolean,
    createButton: Boolean,
  },
  data() {
    return {
      headers: [
        {text: 'Status', value: 'closed', align: 'center', sortable: true},
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Invoice Date', value: 'date', align: 'center', sortable: false},
        {text: 'Total', value: 'line_total', align: 'center', sortable: true},
        {text: 'Total GST', value: 'total', align: 'center', sortable: true},
      ],
      editedIndex: -1,
      editedNote: {
        id: 0,
        client_name: '',
        state: '',
        postcode: '',
        due: '',
        total: '',
        closed: false
      },
      defaultNote: {
        id: 0,
        client_name: '',
        state: '',
        postcode: '',
        due: '',
        total: '',
        closed: false
      },
      editDialog: false,
      creditNoteDisplayerDialog: false,
      toBeClosed: null,
      confirmCloseDialog: false,
      loadingDownload: false,
      emailTo: null,
      emailRules: [],
      deleteDialog:false,
      toBeDeleted:null
    }
  },
  computed: {
    editPermission() {
      return this.$store.getters['auth/hasPermission']('invoice_edit');
    },
  },
  watch: {
    emailTo: function (mail) { // emailTo is the exact name used in v-model
      if (mail !== '' && mail !== null) {
        this.emailRules = [v => (v.match(/^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/)) || 'Invalid Email address (Don \'t put space after the coma if multiple addresses)']
      } else if (mail === '') {
        this.emailRules = []
      }
    },
  },
  mounted() {
    if (this.editPermission) {
      this.headers.push({text: 'Actions', align: 'center', sortable: false})
    }
  },
  methods: {
    deleteRow(row){
      this.toBeDeleted=row;
      this.deleteDialog=true;
    },
    DeleteCreditNote(){
      if(this.toBeDeleted===null) return;

      axios.delete(process.env.API_URL + '/invoices/' + this.toBeDeleted.inv_number
        + '/creditnotes/' + this.toBeDeleted.id)
        .then((response) => {
          this.$store.commit('displaySnackbar', 'Credit note deleted successfully');
          //refresh
          this.$emit('refresh-data',this.toBeDeleted.inv_number);
          this.toBeDeleted=null;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'Credit note deleted ERROR ' + response.response.data.error);
        });

      this.deleteDialog = false;
    },
    exportCreditNote(item){
      window.open(
        process.env.API_URL + '/invoices/' + item.inv_number + '/creditnotes/' + item.id
        + '/csv' + '?key=' + encodeURI(this.$store.state.auth.key),
        '_blank'
      );
    },
    // @vuese
    // Get and export csv summary file from a credit note object
    // @arg Takes credit note object (the one of the row you clicked on) as an argument
    csvExport(item) {
      // Getting data from this row
      // Converting item into an array of exportable data
      axios.get(process.env.API_URL + '/invoices/' + item.inv_number + '/creditnotes/' + item.id)
        .then((response) => {
          this.editedNote = response.data;

          let arrData = [];
          for (var sectionIndex = 0; sectionIndex < this.editedNote.sections.length; sectionIndex++) {
            for (var rowIndex = 0; rowIndex < this.editedNote.sections[sectionIndex].rows.length; rowIndex++) {
              arrData.push(this.editedNote.sections[sectionIndex].rows[rowIndex]);
            }
            console.log(this.editedNote.sections[sectionIndex]);
          }

          console.log(arrData);


          let csvContent = "data:text/csv;charset=utf-8,";
          csvContent += [
            Object.keys(arrData[0]).join(","),
            ...arrData.map(item => {
              let row = Object.values(item).map((value) => {
                return '\"' + value + '\"'
              })
              return row.join(",")
            })
          ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          const data = encodeURI(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", "creditNote.csv");
          link.click();
        })
    },
    // @vuese
    // Gets and download credit note pdf file
    // @arg Takes the credit note object (the one of the row you clicked on) as an argument
    downloadPdfInvoice(item) {
      this.loadingDownload = true;
      axios({
        url: process.env.API_URL + '/invoices/' + this.creditNoteInformation.inv_number
          + '/creditnotes/' + item.id + '/pdf',
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          if (response.status === 200) {
            var url = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Invoice ' + item.id + '.pdf');
            document.body.appendChild(link);
            link.click();
          } else {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.status);
          }
          this.loadingDownload = false;
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + error);
          this.loadingDownload = false;
        })

    },
    // @vuese
    // Displays credit note pdf file in another tab
    // @arg Takes the credit note object (the one of the row you clicked on) as an argument
    displayPdfInvoice(item) {
      let extension = this.closed ? '/pdf' : '/html';
      window.open(process.env.API_URL + '/invoices/' + this.creditNoteInformation.inv_number
        + '/creditnotes/' + item.id + extension + '?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    // @vuese
    // Closes the toBeClosed credit note and send or not the invoice depending on the argument.
    // @arg Takes 'yes'/'no' String from the close dialog depending on whether the function should send or not the invoice
    closeCreditNote(str) {
      if (str === 'no') {
        // User doesn't want to send invoice
        axios.post(process.env.API_URL + '/invoices/' + this.toBeClosed.inv_number
          + '/creditnotes/' + this.toBeClosed.id + '/close')
          .then((response) => {
            this.$store.commit('displaySnackbar', 'Credit Note nº ' + this.toBeClosed.id + ' closed.');
            Object.assign(this.creditNoteInformation[this.creditNoteInformation.indexOf(this.toBeClosed)], response.data);
            this.confirmCloseDialog = false;
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'ERROR' + error.error);
          })
      } else if (str === 'yes') {
        let body = {};
        if (this.emailTo !== null && this.emailTo.length > 0) {
          // User filled an email
          body = {send: true, to: this.emailTo}
        } else {
          body = {send: true}
        }

        axios.post(process.env.API_URL + '/invoices/' + this.toBeClosed.inv_number
          + '/creditnotes/' + this.toBeClosed.id + '/close', body)
          .then((response) => {
            this.$store.commit('displaySnackbar', 'Credit Note nº ' + this.toBeClosed.id + ' closed.');
            Object.assign(this.creditNoteInformation[this.creditNoteInformation.indexOf(this.toBeClosed)], response.data);
            this.confirmCloseDialog = false;
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'ERROR' + error.error);
          });
        this.emailTo = null;
      }
    },
    // @vuese
    // Stores the credit note user wants to delete in toBeClosed variable and toggles close dialog
    // @arg Credit note object user wants to delete (the one of the row he clicked on)
    displayCloseMessage(item) {
      this.confirmCloseDialog = true;
      this.toBeClosed = item
    },
    // @vuese
    // Toggles credit note dialog and updates credit note table
    toggleCreditNoteDialog() {
      this.creditNoteDisplayerDialog = !this.creditNoteDisplayerDialog;
      this.$emit('update-credit-note-table');
    },
    // @vuese
    // Gets info from the credit note we just clicked on. Toggles credit note displayer
    // @arg Takes credit note object user clicked on as an argument
    clickEdit(item) {
      axios.get(process.env.API_URL + '/invoices/' + item.inv_number + '/creditnotes/' + item.id)
        .then((response) => {
          this.creditNoteDisplayerDialog = true;
          this.editedNote = response.data;
        })
        .catch((response) => {

        })

      // this.editDialog = true;
    },
    cancelEdit(item) {
      this.editedNote = this.defaultNote;
      this.editDialog = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/CreditNoteTable.vue